<script lang="ts">
    import { _ } from 'svelte-i18n';

    import type { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import IconDropup from './Icons/IconDropup.svelte';
    import IconDropdown from './Icons/IconDropdown.svelte';

    export let jobFilter: ApiFilterBuilder;
    export let onFilterChange: () => void;
    export let label: string;
    export let className: string;
    export let fieldName: string | null;

    function getStyle(direction: string, jobFilter: ApiFilterBuilder) {
        let addOpacity = 'opacity: 0.3';
        if (jobFilter.getSortBy()?.field !== fieldName) {
            return addOpacity;
        }
        if (jobFilter.getSortBy()?.direction === direction) {
            addOpacity = 'opacity: 1';
        }
        return addOpacity;
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="{className} column-sortable dont-break"
    class:sortByHeader={jobFilter.getSortBy()?.field === fieldName}
    on:click={() => {
        if (fieldName === null) {
            return false;
        }
        jobFilter.toggleSortBy([fieldName]);
        onFilterChange();
    }}
>
    <div
        title={jobFilter.getSortBy()?.field}
        data-field={jobFilter.getSortBy()?.field}
        data-fieldName={fieldName}
        data-sortBy={jobFilter.getSortBy()?.direction}
    >
        {$_(label)}
    </div>
    {#if fieldName !== null}
        <div style="position: relative">
            <div style="position: absolute; bottom: -10px; left: -6px; ">
                <IconDropup scale={0.9} style={getStyle('asc', jobFilter)} />
            </div>
            <div style="position: absolute; bottom: -18px; left: -6px;">
                <IconDropdown scale={0.9} style={getStyle('desc', jobFilter)} />
            </div>
        </div>
    {/if}
</div>

<style>
    .column-sortable {
        border-radius: 3px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 5px;
        padding-top: 5px;
    }
    .column-sortable:hover {
        cursor: pointer;
        background-color: var(--main-selected-background);
        transition: 0.2s;
    }
</style>
